const assert = require('assert');


describe('Require Inject All', function() {
  it('will resolve with empty array if the directory does not exist', async function() {
    assert.equal(1, 1);
    const inject = require('../');

    const results = await inject('wefoij23/sadflifj');
    assert.deepEqual(results, [], 'Should be empty');

  });

  it('should find three modules', async function() {

    const inject = require('../index');
    const objectToPass = {testKey: 'bark'};
    const results = await inject(process.cwd() + '/src/node_modules/require-inject-all/test/test-modules', objectToPass);

    assert.equal(Object.keys(results).length, 3, 'There should be two endpoints found');
    assert.ok(Object.keys(results).indexOf('modA_in_folder')>=0);
    assert.ok(Object.keys(results).indexOf('modB_file_module')>=0);
    assert.ok(Object.keys(results).indexOf('no_promise_returned')>=0);
    assert.equal(results.no_promise_returned, 'I am not a promise');

    assert.equal(objectToPass.testKey, 'bark', 'The test key should not be modified');
    assert.equal(objectToPass.modAInfo, 'hello', 'Module A should have put a prop modAInfo on the object');
    assert.equal(objectToPass.modBInfo, 'meow', 'Module B should have put a prop modBInfo on the object');


  });

  it('should throw if a module throws', async function() {
    const inject = require('../index');
    let error;

    try {
      const results = await inject(process.cwd() + '/src/node_modules/require-inject-all/test/junk-folder');
      assert.fail('Should not reach here');
    } catch (e) {
      error = e;
    }
    assert.equal(error.message, 'Derp', 'catch was excepting to run');

  });

});
